import { db } from "../firebase";
import {
  doc,
  onSnapshot,
  getDocs,
  query,
  where,
  collection,
  getDoc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";

export const checkFourByFourStatus = async (userId) => {
  console.log(`🔍 Checking 4x4 status for: ${userId}`);

  try {
    const docRef = doc(db, "trackers", userId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      console.log("❌ No tracker found for this user ID.");
      return 0;
    }

    const data = docSnap.data();
    const f = data.fourByFour;
    if (!f) {
      console.log(`⚠️ No fourByFour data found in document: ${docSnap.id}`);
      return 0;
    }

      const failures = [];

      // ---- Level 1 checks ----
      if (f.personalSavings !== true) failures.push("personalSavings is false or missing");
      if (f.bigEvent !== true) failures.push("bigEvent is false or missing");
      if (f.finish1stRecruit !== true) failures.push("finish1stRecruit is false or missing");

      const isFirstValid = failures.length === 0;

      // ---- Level 2 checks ----
      const secondFailures = [];

      if (f.licensed !== true) secondFailures.push("licensed is false or missing");
      if (f.finish2ndRecruit !== true) secondFailures.push("finish2ndRecruit is false or missing");
      if (f.finish3rdRecruit !== true) secondFailures.push("finish3rdRecruit is false or missing");

      if (typeof f.finish4thSavingsAmount !== "number" || f.finish4thSavingsAmount <= 0)
        secondFailures.push(`finish4thSavingsAmount invalid (${f.finish4thSavingsAmount})`);

      if (typeof f.finish3rdSavingsAmount !== "number" || f.finish3rdSavingsAmount <= 0)
        secondFailures.push(`finish3rdSavingsAmount invalid (${f.finish3rdSavingsAmount})`);

      if (typeof f.finish2ndSavingsAmount !== "number" || f.finish2ndSavingsAmount <= 0)
        secondFailures.push(`finish2ndSavingsAmount invalid (${f.finish2ndSavingsAmount})`);

      if (typeof f.personalSavingsAmount !== "number" || f.personalSavingsAmount <= 0)
        secondFailures.push(`personalSavingsAmount invalid (${f.personalSavingsAmount})`);

      if (!f.passExamDate || isNaN(new Date(f.passExamDate).getTime()))
        secondFailures.push(`passExamDate invalid (${f.passExamDate})`);

      const isSecondValid = secondFailures.length === 0;

      // ---- Logging ----
      if (failures.length > 0)
        console.log(`❌ Level 1 (Initial) validation failed for ${userId}:`, failures);

      if (secondFailures.length > 0)
        console.log(`❌ Level 2 (Full) validation failed for ${userId}:`, secondFailures);

      // ---- Decision ----
      if (isFirstValid && isSecondValid) {
        console.log("✅ FourByFour fully valid");
        return 2;
      }

      if (isFirstValid) {
        console.log("✅ FourByFour partially valid (Level 1 passed)");
        return 1;
      }

    console.log("❌ FourByFour failed all required conditions.");
    return 0;
  } catch (error) {
    console.error("🔥 Error checking fourByFour status:", error);
    return 0;
  }
};


export const checkAssociateStatus = async (userId) => {
  console.log(`🔍 Checking associate status for: ${userId}`);

  try {
    const docRef = doc(db, "trackers", userId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) {
      console.log("❌ No tracker found for this user ID.");
      return 0;
    }

    const booleanFields = [
      "multiHanded",
      "tenThreeRulesGoals",
      "selfImprovement",
      "obsRecruitsDone",
      "obsClientsDone",
      "getLicense",
      "registerConvention",
      "keyPlayer",
      "training",
      "bigEvent",
    ];

    const numberFields = [
      "recruitsTtl",
      "personalPoints",
      "licensesTtl",
      "registrationsBase",
      "netLicense",
    ];

    const data = docSnap.data();
    const a = data.associate;
    if (!a) {
      console.log(`⚠️ No associate data found in document: ${docSnap.id}`);
      return 0;
    }

      const failedFields = [];

      // Check boolean fields
      for (const field of booleanFields) {
        if (a[field] !== true) failedFields.push(`${field} is false or missing`);
      }

      // Check number fields
      for (const field of numberFields) {
        if (typeof a[field] !== "number" || a[field] <= 0)
          failedFields.push(`${field} invalid (${a[field]})`);
      }

    if (failedFields.length > 0) {
      console.log(`❌ Associate validation failed for ${userId}:`, failedFields);
      return 0;
    } else {
      console.log("✅ Associate validation fully passed");
      return 1;
    }
  } catch (error) {
    console.error("🔥 Error checking associate status:", error);
    return 0;
  }
};


